import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { CustomerSubscriptionItem } from 'src/app/shared/models/CustomerSubscription.item';
import { AppService } from './app.service';

@Injectable({
	providedIn: 'root',
})
export class SubscriptionItemService {
	cartItems: BehaviorSubject<CustomerSubscriptionItem[]> = new BehaviorSubject<CustomerSubscriptionItem[]>([]);
	totalCartAmount: number;

	customer: SubscriptionOrderCustomer;

	constructor(private app: AppService) {
		this.cartItems.subscribe((data) => {
			this.calculateCartTotal();
		});

		this.customer = new SubscriptionOrderCustomer({
			orderKey: this.app.uuidv4(),
		});
	}

	calculateCartTotal() {
		let total: number = 0;
		this.cartItems.value.forEach((item) => {
			total += item.price * item.quantity;
		});
	}
}

export class SubscriptionOrderCustomer {
	orderKey: string;
	firstName: string;
	lastName: string;
	email: string;
	phone: string;
	street1: string;
	street2: string;
	city: string;
	state: string;
	postalCode: string;
	cartItems: CustomerSubscriptionItem[];
	cardToken: string;
	shipTo: SubscriptionOrderCustomer;

	public constructor(init?: Partial<SubscriptionOrderCustomer>) {
		Object.assign(this, init);
	}
}
